import React from 'react';
import { Link } from 'react-router-dom';
import PublicNavbar from '../components/PublicNavbar';
import './PrivacyPolicy.css';

/** Content sourced from Policies.pdf (Refund and Cancellation policy). */

const RefundPolicy: React.FC = () => {
  return (
    <div className="privacy-policy">
      <PublicNavbar>
        <Link to="/terms-and-conditions">Terms</Link>
        <Link to="/refund-policy">Refunds</Link>
        <Link to="/customer/login" className="nav-btn nav-btn-customer">Promoter Login</Link>
        <Link to="/admin/login" className="nav-btn nav-btn-admin">Admin Login</Link>
      </PublicNavbar>

      <main className="policy-content">
        <div className="container">
          <h1>Refund and Cancellation Policy &ndash; TappyTray</h1>
          <p className="last-updated"><strong>Last Updated: 16 May 2026</strong></p>

          <p>
            This refund and cancellation policy outlines how you can cancel or seek a refund for a product / service
            that you have purchased through the Platform. Under this policy:
          </p>

          <section>
            <h2>1. Order cancellations</h2>
            <p>
              Cancellations will only be considered if the request is made within <strong>1 day</strong> of placing the order.
              However, cancellation requests may not be entertained if the orders have been communicated to such sellers /
              merchant(s) listed on the Platform and they have initiated the process of shipping them, or the
              product is out for delivery. In such an event, you may choose to reject the product at the doorstep.
            </p>
          </section>

          <section>
            <h2>2. Perishable items</h2>
            <p>
              TappyTray does not accept cancellation requests for perishable items like flowers, eatables, etc.
              However, the refund / replacement can be made if the user establishes that the quality of the
              product delivered is not good.
            </p>
          </section>

          <section>
            <h2>3. Damaged or defective items</h2>
            <p>
              In case of receipt of damaged or defective items, please report to our customer service team. The
              request would be entertained once the seller / merchant listed on the Platform has checked and
              determined the same at its own end. This should be reported within <strong>1 day</strong> of receipt of products.
            </p>
          </section>

          <section>
            <h2>4. Product not as described</h2>
            <p>
              In case you feel that the product received is not as shown on the site or as per your expectations,
              you must bring it to the notice of our customer service within <strong>1 day</strong> of receiving the product. The
              customer service team after looking into your complaint will take an appropriate decision.
            </p>
          </section>

          <section>
            <h2>5. Manufacturer warranty</h2>
            <p>
              In case of complaints regarding the products that come with a warranty from the manufacturers,
              please refer the issue to them.
            </p>
          </section>

          <section>
            <h2>6. Refund processing time</h2>
            <p>
              In case of any refunds approved by TappyTray, it will take <strong>10 days</strong> for the refund to be processed
              to you.
            </p>
          </section>

          <section>
            <h2>Contact</h2>
            <div className="contact-info">
              <p>For cancellation and refund queries, contact:</p>
              <p><strong>BoilingCode LLP</strong><br />Operator of TappyTray</p>
              <p><strong>Email</strong>: <a href="mailto:yogita@boilingcode.com">yogita@boilingcode.com</a></p>
              <p><strong>Website</strong>: <a href="https://tappytray.com">www.tappytray.com</a></p>
            </div>
          </section>
        </div>
      </main>

      <footer className="footer">
        <div className="container">
          <p>&copy; 2026 BoilingCode LLP. All rights reserved.</p>
          <div className="footer-links">
            <Link to="/">Home</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
            <Link to="/refund-policy">Refund Policy</Link>
            <Link to="/delete-account">Delete Account</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default RefundPolicy;
